<template>
  <header>
    <div class="_top-bar">
      <div>
        <account-menu></account-menu>
      </div>
    </div>
  </header>
</template>

<script>
import Vue from "vue";

import AccountMenu from "./AccountMenu.vue";

export default Vue.extend({
  name: "PageHeader",
  components: {
    AccountMenu,
  },
  data() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
header {
  background: color("panel");
  border-bottom: 1px solid color("containerBorder");

  ._top-bar {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1em 0;
  }

  ._actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .plushie-search {
    position: relative;

    input {
      margin-bottom: 0;
      padding-left: 2em;
    }

    ._search-icon {
      align-items: center;
      color: color("text");
      display: flex;
      flex-direction: row;
      font-size: 120%;
      height: 100%;
      justify-content: flex-end;
      left: 0;
      padding: 0.5em;
      position: absolute;
      top: 0;
    }
  }

  ._notifications {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: 2em;
    position: relative;

    i {
      display: block;
      font-size: 200%;
      line-height: 1;
    }

    ._badge {
      position: absolute;
      right: -1.2em;
      top: -0.9em;
      font-size: 80%;
      align-items: center;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      //padding: .5em;
      height: 1.8em;
      width: 1.8em;
    }

    ._item {
      cursor: pointer;
      margin-right: 1.2em;
      position: relative;

      &.-unread-messages {
        //color: #9C27B0;

        ._badge {
          background: color("alert");
          color: color("page");
        }
      }
    }
  }

  .title-bar {
    //background: color('page');
    //color: color('text');
  }
}
</style>
